// extracted by mini-css-extract-plugin
module.exports = {"card":"SimilarProductCard_card__Lpxb3","content":"SimilarProductCard_content__BqBYU","title":"SimilarProductCard_title__igJnC"};